import { Component, OnInit, ElementRef, ViewChild, forwardRef, Input, SimpleChanges, OnChanges, HostListener, HostBinding, Output, EventEmitter, Inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { isNil, set } from 'lodash-es';
import { Styles } from './models/style';
import { SelectorComponent } from './components/selector.component';
import { ESelectorType } from './components/selector.component';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { ShippingContainers_ShellService } from './ShippingContainers.shell.service';
import { ShippingContainers_OperationService } from './ShippingContainers.operation.service';
import { ShippingContainers_DatasourceService } from './ShippingContainers.datasource.index';
import { ShippingContainers_FlowService } from './ShippingContainers.flow.index';
import { ShippingContainers_ReportService } from './ShippingContainers.report.index';
import { ShippingContainers_LocalizationService } from './ShippingContainers.localization.service';
import { ShippingContainers_shipping_container_dates_dd_ComponentContextService } from './ShippingContainers.shipping_container_dates_dd.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './ShippingContainers.frontend.types'
import { $frontendTypes as $types} from './ShippingContainers.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'ShippingContainers-shipping_container_dates_dd_single',
  templateUrl: './ShippingContainers.shipping_container_dates_dd_single.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ShippingContainers_shipping_container_dates_dd_singleComponent),
      multi: true
    }
  ]
})
export class ShippingContainers_shipping_container_dates_dd_singleComponent extends BaseComponent implements OnInit, ControlValueAccessor {

  @Input() type?: ESelectorType;
  _disabled = false;
  @Input() get disabled() { 
      return this._disabled 
      ; }
  set disabled(val: any) { this._disabled = val; }

  @Input() placeholder = '';
  @Input() styles: Styles;
  @Input() tooltip = '';

  @Output() displayTextChange: EventEmitter<string> = new EventEmitter();

  @ViewChild(SelectorComponent) selector: SelectorComponent;
  
  @HostBinding('tabIndex') get tabIndex() { return -1; }
  @HostListener('focus')
  focus() {
    this.selector?.focus();
  }

  get isMulti() {
    return false;
  }

  get isSingle() {
    return true;
  }

  options: Array<{ key: any; name: string; disabled?: boolean; }> = [
    {
      key: 'CreatedSysDateTime',
      name: 'Created Date',
      disabled: null
    },  
    {
      key: 'EstimatedDeliveryDateTime',
      name: 'Estimated Delivery Date',
      disabled: null
    },  
    {
      key: 'ModifiedSysDateTime',
      name: 'Modified Date',
      disabled: null
    },  
    {
      key: 'PackVerification',
      name: 'Pack Verification',
      disabled: null
    },  
    {
      key: 'SailOnBoard',
      name: 'Sail On Board',
      disabled: null
    },  
    {
      key: 'ShippingDate',
      name: 'Shipping Date',
      disabled: null
    },  
  ];


  fullTextSearch: string;

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: ShippingContainers_ShellService,
    private $datasources: ShippingContainers_DatasourceService,
    private $flows: ShippingContainers_FlowService,
    private $reports: ShippingContainers_ReportService,
    private $localization: ShippingContainers_LocalizationService,
    private $operations: ShippingContainers_OperationService,
    private $logger: CleanupLoggerService,
    private $context: ShippingContainers_shipping_container_dates_dd_ComponentContextService,
    private _elementRef: ElementRef
    ) {
    super();
  }

  ngOnInit(): void {
    this.$init();
  }
  

  
  async $init() {
    this.selector?.init();
  }

  onKeyDown($event: KeyboardEvent) {
    //TODO:KeyDown    
  }

  //ControlValueAccessor
  _innerValue: any;

  onChange: any = () => { };
  onTouch: any = () => { };

  get value(): string | string[] {
    return this._innerValue;
  }

  set value(val: string | string[]) {
    if (this._innerValue !== val) {
      this._innerValue = val;
      this.onChange(val);
      this.onTouch(val);
    }
  }

  writeValue(value: any): void {
    this._innerValue = value;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }


  displayWithFn(value: any): Promise<string> {
    const displayTextResult = this.options.find(o => o.key === value).name;
    this.displayTextChange.emit(displayTextResult);
    return Promise.resolve(displayTextResult);
  }

  optionsFn(filterText: string): Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }> {
    if (filterText.length > 0) {
      const list = this.options.filter(item => item.name.startsWith(filterText))
      return Promise.resolve({ list, totalCount: this.options.length, top: null });
    } else {
      const list = [...this.options];
      return Promise.resolve({ list, totalCount: this.options.length, top: null });
    }
  }

}
